import { defineMessages } from 'react-intl'

export default defineMessages({
  metaTitle: {
    id: 'landing.metaTitle',
    defaultMessage: 'Sijilo — Calm, modern clinic management'
  },
  metaDescription: {
    id: 'landing.metaDescription',
    defaultMessage:
      'Run patient records, visits, scheduling, queue management, prescriptions, and growth tracking from one clear workspace.'
  },
  eyebrow: {
    id: 'landing.eyebrow',
    defaultMessage: 'Clinic operations, simplified'
  },
  heroTitle: {
    id: 'landing.heroTitle',
    defaultMessage: 'One calm workspace for your entire clinic.'
  },
  heroDescription: {
    id: 'landing.heroDescription',
    defaultMessage:
      'Sijilo keeps patient records, daily operations, and clinical follow-through together—so your team can focus on care, not software.'
  },
  bookDemo: {
    id: 'landing.bookDemo',
    defaultMessage: 'Book a demo'
  },
  explorePlatform: {
    id: 'landing.explorePlatform',
    defaultMessage: 'Explore the platform'
  },
  builtFor: {
    id: 'landing.builtFor',
    defaultMessage: 'Built for independent doctors and growing clinic teams.'
  },
  previewToday: {
    id: 'landing.preview.today',
    defaultMessage: 'Today at the clinic'
  },
  previewDate: {
    id: 'landing.preview.date',
    defaultMessage: 'Tuesday, 2 September'
  },
  previewSearch: {
    id: 'landing.preview.search',
    defaultMessage: 'Search patients…'
  },
  previewWaiting: {
    id: 'landing.preview.waiting',
    defaultMessage: 'Waiting'
  },
  previewVisits: {
    id: 'landing.preview.visits',
    defaultMessage: 'Visits'
  },
  previewPatients: {
    id: 'landing.preview.patients',
    defaultMessage: 'Patients'
  },
  previewQueue: {
    id: 'landing.preview.queue',
    defaultMessage: 'Live queue'
  },
  previewFollowUp: {
    id: 'landing.preview.followUp',
    defaultMessage: 'Follow up'
  },
  previewCompleted: {
    id: 'landing.preview.completed',
    defaultMessage: '12 completed this week'
  },
  proofRecord: {
    id: 'landing.proof.record',
    defaultMessage: 'One complete patient record'
  },
  proofQueue: {
    id: 'landing.proof.queue',
    defaultMessage: 'A live team queue'
  },
  proofClinical: {
    id: 'landing.proof.clinical',
    defaultMessage: 'Built-in clinical tools'
  },
  proofBilingual: {
    id: 'landing.proof.bilingual',
    defaultMessage: 'English and Arabic'
  },
  featuresLabel: {
    id: 'landing.features.label',
    defaultMessage: 'Everything in its place'
  },
  featuresTitle: {
    id: 'landing.features.title',
    defaultMessage: 'A clinic system that feels considered.'
  },
  featuresDescription: {
    id: 'landing.features.description',
    defaultMessage:
      'Every workflow shares the same clear structure, from the first patient search to the final prescription.'
  },
  patientRecordsTitle: {
    id: 'landing.features.patientRecords.title',
    defaultMessage: 'Complete patient records'
  },
  patientRecordsDescription: {
    id: 'landing.features.patientRecords.description',
    defaultMessage:
      'History, visits, measurements, attachments, and follow-ups stay connected in one dossier.'
  },
  queueTitle: {
    id: 'landing.features.queue.title',
    defaultMessage: 'A queue the whole team can see'
  },
  queueDescription: {
    id: 'landing.features.queue.description',
    defaultMessage:
      'Secretaries manage arrivals while doctors open the next patient directly from their workspace.'
  },
  visitsTitle: {
    id: 'landing.features.visits.title',
    defaultMessage: 'Visit workflows that fit your practice'
  },
  visitsDescription: {
    id: 'landing.features.visits.description',
    defaultMessage:
      'Capture the details you need with specialty-aware forms, follow-ups, and a readable timeline.'
  },
  schedulingTitle: {
    id: 'landing.features.scheduling.title',
    defaultMessage: 'Scheduling without the clutter'
  },
  schedulingDescription: {
    id: 'landing.features.scheduling.description',
    defaultMessage:
      'Keep upcoming work visible with focused day, week, and list calendar views.'
  },
  clinicalToolsTitle: {
    id: 'landing.features.clinicalTools.title',
    defaultMessage: 'Clinical tools, close at hand'
  },
  clinicalToolsDescription: {
    id: 'landing.features.clinicalTools.description',
    defaultMessage:
      'Generate visit summaries and prepare printable prescriptions without leaving the patient record.'
  },
  growthTitle: {
    id: 'landing.features.growth.title',
    defaultMessage: 'Growth tracking built in'
  },
  growthDescription: {
    id: 'landing.features.growth.description',
    defaultMessage:
      'Review pediatric measurements against standardized percentile curves as part of the clinical record.'
  },
  workflowLabel: {
    id: 'landing.workflow.label',
    defaultMessage: 'One continuous workflow'
  },
  workflowTitle: {
    id: 'landing.workflow.title',
    defaultMessage: 'From arrival to follow-up, nothing gets lost.'
  },
  workflowStepOneTitle: {
    id: 'landing.workflow.stepOne.title',
    defaultMessage: 'Welcome the patient'
  },
  workflowStepOneDescription: {
    id: 'landing.workflow.stepOne.description',
    defaultMessage:
      'Find an existing record or create a new one, then add the patient to the live queue.'
  },
  workflowStepTwoTitle: {
    id: 'landing.workflow.stepTwo.title',
    defaultMessage: 'Run the visit'
  },
  workflowStepTwoDescription: {
    id: 'landing.workflow.stepTwo.description',
    defaultMessage:
      'Open the dossier, record clinical details, and see the full history without changing context.'
  },
  workflowStepThreeTitle: {
    id: 'landing.workflow.stepThree.title',
    defaultMessage: 'Close the loop'
  },
  workflowStepThreeDescription: {
    id: 'landing.workflow.stepThree.description',
    defaultMessage:
      'Create prescriptions, schedule follow-ups, and return to exactly the view you prefer next time.'
  },
  growthLabel: {
    id: 'landing.growth.label',
    defaultMessage: 'Useful before you sign up'
  },
  growthHeading: {
    id: 'landing.growth.heading',
    defaultMessage: 'Try pediatric growth charts for free.'
  },
  growthBody: {
    id: 'landing.growth.body',
    defaultMessage:
      'Plot weight, height, BMI, and head circumference against WHO percentile curves. No account required.'
  },
  growthMetric: {
    id: 'landing.growth.metric',
    defaultMessage: 'Weight for age'
  },
  growthOverview: {
    id: 'landing.growth.overview',
    defaultMessage: 'Percentile overview'
  },
  openGrowthCharts: {
    id: 'landing.growth.open',
    defaultMessage: 'Open growth charts'
  },
  ctaTitle: {
    id: 'landing.cta.title',
    defaultMessage: 'A quieter way to run your clinic.'
  },
  ctaDescription: {
    id: 'landing.cta.description',
    defaultMessage:
      'Book a walkthrough and see how Sijilo can fit the way your team already works.'
  },
  footerTagline: {
    id: 'landing.footer.tagline',
    defaultMessage: 'Modern clinic management, without the noise.'
  },
  footerRights: {
    id: 'landing.footer.rights',
    defaultMessage: '© 2026 Sijilo. All rights reserved.'
  }
})
